import { Flex, Box } from './layouts';
import OpenSvg from 'imagesUwKluis/svg/open.svg';
import css from '@styled-system/css';
import {FC} from "react";

interface Props {
  descriptor: string;
  value: string;
  details?: string;
  action?: () => void;
  isResult?: boolean;
  hideIfEmpty?: boolean;
}

const OverviewDetailRow: FC<Props> = ({
  descriptor,
  value,
  details,
  action,
  isResult,
  hideIfEmpty,
}) => {
  if (hideIfEmpty && !value) return null;

  return (
    <Flex
      alignItems={'center'}
      height={'52px'}
      py={'m'}
      fontScale={'s'}
      backgroundColor={isResult ? 'primaryBackground' : null}
      onClick={action ? action : null}
      css={{ cursor: action ? 'pointer' : null }}
    >
      <Box
        flex="30% 1 0"
        fontWeight={isResult ? 'bold' : null}
        pl={isResult ? 's' : null}
      >
        {descriptor}
      </Box>
      <Box flex="50% 1 0">{value}</Box>
      <Box flex="15% 1 0" fontWeight={isResult ? 'bold' : null}>
        {details}
      </Box>
      <Box flex={'24px 0 0'}>
        {action && (
          <OpenSvg
            css={css({
              fill: 'primary',
              flexShrink: '0',
            })}
            display={'block'}
            width="1.5rem"
            height="1.5rem"
          />
        )}
      </Box>
    </Flex>
  );
};

export default OverviewDetailRow;
